module.exports = __webpack_public_path__ + "img/logo-CEX.4f91d1cf.png";